import { DonutChartItem } from "react-charts";
import { WeekDataRecord } from "react-charts/dist/week-chart/week-chart-model";
import { ChannelReport } from "../channels-page/channel-models";
import { FullReportEntry } from "../models/FullReportEntry";
import { AdSummary } from "./AdSummary";

export const sampleBreakdown = {
    age: {
      '18-24': 2,
      '25-34': 249,
      '35-44': 390,
      '45-54': 386,
      '55-64': 214,
      '65+': 136
    },
    platform: { facebook: 844, instagram: 530, messenger: 3 },
    gender: { female: 1268, male: 109, unknown: 15 }
}


export type BreakDownReport = {
    age?: Record<'18-24' |'25-34' | '35-44' | '45-54' | '55-64' | '65+', number>,
    platform?: Record<'facebook' |'instagram' | 'messenger' | '45-54' | '55-64' | '65+', number>,
    gender?: Record<'female' | 'male' | 'unknown', number>
}

export type ReportType = keyof BreakDownReport;


export type Age = keyof BreakDownReport['age']
export type Platform = keyof BreakDownReport['platform']
export type Gender = keyof BreakDownReport['gender']
type BreakDowns = Age|Platform|Gender

export function getLabel(type: ReportType){
    switch(type){
        case "age": return "Idade"
        case "gender": return "Gênero"
        case "platform": return "Plataforma"
        default: return type;
    } 
}

export function getLabelColor(key:BreakDowns):{label:string, style:string}{
    switch(key){
        case "18-24": return {label: key, style: "color1"}
        case "25-34": return {label: key, style: "color2"}
        case "35-44": return {label: key, style: "color14"}
        case "45-54": return {label: key, style: "color4"}
        case "55-64": return {label: key, style: "color17"}
        case "65+": return {label: key, style: "color15"}

        case "facebook": return {label: "Facebook", style: "color3"}
        case "instagram": return {label: "Instagram", style: "color6"}
        case "messenger": return {label: "Messenger", style: "color8"}

        case "male": return {label: "Masculino", style: "color3"}
        case "female": return {label: "Feminino", style: "color14"}
        case "unknown": return {label: "Não Informado", style: "color16"}

        default: return {label: key, style: "color15"}
    }
}

export function breakDownToDonut(breakdown: BreakDownReport){
    const result:Partial<Record<ReportType, DonutChartItem[]>> = {};
    for(const [key, value] of Object.entries(breakdown)){
        const a = Object.entries(value).map(([k, v]) => ({...getLabelColor(k as BreakDowns), value:v}));
        if(Object.entries(a).length)
            result[key as ReportType] = a;
    }
    return result;
}


export type DetailReportData = {
    breakdowns: BreakDownReport,
    ads: AdSummary[]
    hourlyReport?: WeekDataRecord
    updatedAt: number
}

export type DetailReport = {
    channel: ChannelReport,
    detail: DetailReportData,
    report: FullReportEntry
}